import { inject, injectable } from 'inversify';
import Debug from 'debug';
import * as Api from '@xlearn/common';
import { BadgeStoreModule, BadgeStoreModuleSymbol, Badge } from '../../store';
import { MsgPackCourseFileLoader, MsgPackCourseFileLoaderSymbol } from '@/app/fetch/msgpack-course-file';
import { CancelToken } from '@/app/shared/utils';
import { replaceBasePathInContent } from '@/app/shared/utils/base-path';

const debug = Debug('load-badges-command');

export interface BadgeUri {
  uri: string;
  basePath: string;
}

@injectable()
export class LoadBadgesCommand {

  constructor(
    @inject(BadgeStoreModuleSymbol)
    private store: BadgeStoreModule,
    @inject(MsgPackCourseFileLoaderSymbol)
    private fileLoader: MsgPackCourseFileLoader) {
  }

  public async execute(source: BadgeUri, cancelToken: CancelToken) {

    debug('loading badge file', source);

    this.store.startLoading();

    const loadResult = await this.fileLoader.load<Api.SerializedBadge[]>(source.uri, cancelToken)
    if (!loadResult.success) {
      return loadResult
    }
    
    const mapped = loadResult.value.map((x) => this.mapBadge(x, source.basePath));

    debug('badge file loaded: %j', mapped);

    this.store.finishLoading(mapped);

    return Api.ok(true as true)
  }

  private mapBadge(badge: Api.SerializedBadge, basePath: string): Badge {

    const replacePath = replaceBasePathInContent(basePath)
    
    return {
      id: badge.id,
      title: badge.title,
      imageUri: replacePath(badge.imageUri),
      formula: badge.formula,
      formulaSource: badge.formulaSource,
      descriptionFragment: replacePath(badge.descriptionFragment),
      earnedDescriptionFragment: replacePath(badge.earnedDescriptionFragment)
    };
  }
}
